"use client";

import { Activity, Brain, Compass, Flame, ChartLine as LineChart, Radar } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AgencyFeatures() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const capabilities = [{
    number: "01",
    title: "Custom Website Design",
    description: "High-converting, responsive websites tailored to your brand identity and designed to turn visitors into loyal customers.",
    Icon: LineChart
  }, {
    number: "02",
    title: "Strategic SEO Growth",
    description: "Data-driven search engine optimization strategies that improve your rankings and drive sustainable organic traffic.",
    Icon: Brain
  }, {
    number: "03",
    title: "Local SEO Traffic",
    description: "Dominate your local market by optimizing your presence and ensuring your business is found by nearby customers.",
    Icon: Radar
  }, {
    number: "04",
    title: "SEO-friendly Features",
    description: "Keyword-focused page structure, heading, and content. Optimized title tags and meta descriptions, Fast mobile experience, etc.",
    Icon: Compass
  }, {
    number: "05",
    title: "Performance Analytics",
    description: "Clear, actionable insights into your website performance using Google Analytics and Search Console setup to guide your business decisions further.",
    Icon: Activity
  }, {
    number: "06",
    title: "Conversion Optimization",
    description: "Refining your digital touchpoints to ensure every click has the best chance of becoming a new business lead.",
    Icon: Flame
  }];
  return <section data-section-id="4553" id="seobuiltinfeatures" className="bg-background text-foreground py-20 md:py-28 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-5">
            <p className="font-mono text-xs tracking-widest uppercase text-[color:var(--chart-1)] mb-6">02 / OUR website design seRVICES</p>
            <h2 className="font-default font-semibold leading-[1.05] tracking-tight text-foreground !text-5xl">Website Design With SEO Built In From the Start</h2>
          </div>
          <div className="flex !justify-start !items-center lg:col-span-7 lg:pl-8">
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground/90 max-w-2xl">Many websites look good but are not built for Google. We design websites with SEO structure from the beginning so your business has a stronger foundation for search visibility.</p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border/60">
          {capabilities.map((cap, i) => {
          const Icon = cap.Icon;
          return <div data-index={i} key={cap.number} className="group relative bg-background border border-transparent transition-all duration-500 ease-out p-8 flex flex-col rounded-lg shadow-sm !h-[300px] hover:border-[color:var(--chart-1)]/40 sm:p-10" style={{
            aspectRatio: "4 / 5",
            minHeight: "420px"
          }}>
                {}
                <span className="font-mono text-xs tracking-widest text-[color:var(--chart-1)]">
                  {cap.number}
                </span>

                {}
                <div className="relative flex items-center justify-start mt-10 mb-10">
                  <div aria-hidden="true" className="absolute -inset-6 rounded-lg bg-[color:var(--chart-1)]/15 blur-2xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
                  <Icon strokeWidth={1} className="relative size-8 text-foreground/90 group-hover:text-[color:var(--chart-1)] transition-colors duration-500" />
                </div>

                {}
                <h3 className="font-default font-semibold text-2xl leading-snug text-foreground mb-4">
                  {cap.title}
                </h3>

                {}
                <p className="font-default text-[15px] leading-relaxed text-muted-foreground/80 mb-8">
                  {cap.description}
                </p>

                {}
                
              </div>;
        })}
        </div>

        {}
        
      </div>
    </section>;
}